<template>
  <div>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">일차</th>
        <th scope="col">시간</th>
        <th scope="col">상품</th>
        <th scope="col">소요시간</th>
        <th scope="col">판매금액</th>
        <th scope="col">할인금액</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="travel in filtered_package_list">
        <td>{{ travel.ct_day_order }}일차</td>
        <td>{{ travel.ct_day_time | moment("hh:mm") }}</td>
        <td>
          {{travel.wr_subject}} <span v-if="travel.ct_comment">[ {{travel.ct_comment}} ]</span>
        </td>
        <td>{{travel.ct_usage_time}}</td>
        <template v-if="travel.cs_item_type=='1' || travel.cs_item_type=='0'">
          <td>{{travel.ct_deposit_price | number_format}}</td>
          <td>{{travel.ct_sale_price | number_format}}</td>
        </template>
        <template v-else-if="travel.cs_item_type=='2'">
          <td colspan="2"><a :href="travel.cs_online_purchase_url" target="_blank">인터넷예매</a></td>

        </template>
        <template v-else-if="travel.cs_item_type=='3'">
          <td colspan="2">현장구매</td>

        </template>
        <template v-else-if="travel.cs_item_type=='4'">
          <td colspan="2">무료</td>

        </template>
      </tr>

      <tr>
        <td colspan="3">총합계</td>
        <td>{{sumDepositPrice | number_format}}</td>
        <td>-{{sumSalePrice | number_format}}</td>
        <td>= {{sumDepositPrice - sumSalePrice | number_format}}</td>
      </tr>



      <tr>
        <td colspan="3">입금할 금액</td>
        <td></td>
        <td></td>
        <td>= {{(sumDepositPrice - sumSalePrice)  | number_format}}</td>
      </tr>

      </tbody>
    </table>
    <div style="text-align: center;padding:10px;" >
      <button type="button" @click="set_package">패키지적용</button>
      <button type="button" @click="goto_back">목록으로</button>
    </div>



    <v-dialog  :scrollable="true" />
  </div>



</template>

<script>

  import {Timeline, TimelineItem, TimelineTitle} from 'vue-cute-timeline'

  export default {
    props: ['wr_id','cr_id','cs_bo_table','w'],
    name: "package_view",
    data() {
      return {
        newOpen: '',
        package_list: [],
        additional_discount:null
      }

    },
    computed: {
      filtered_package_list: function () {
        return this.package_list;
      },
      travel_group_by_day: function () {
        var vm = this;
        var a = _.groupBy(this.package_list, function (n) {
          return n.ct_ymd;
        });

        return a;
      },
      sumDepositPrice: function () {
        if (this.package_list.length == 0) return 0;

        let sum = 0;
        this.package_list.forEach(function (travel, index) {

          sum += parseInt(travel.ct_deposit_price);

        })

        return sum;
      },
      sumSalePrice: function () {
        if (this.package_list.length == 0) return 0;

        let sum = 0;
        this.package_list.forEach(function (travel, index) {

          sum += parseInt(travel.ct_sale_price);

        })

        return sum;
      },
    },
    methods: {
      goto_back: function(){
        history.back();
      },
      view_detail: function (ci_id) {

        var vm = this;
        axios.post('/cs_schedule/get_item.php', {
          ci_id: ci_id
        }).then(function (response) {


          vm.$modal.show('dialog', {
            title: response.data.item_name,
            text: response.data.content,
            buttons: [

              {
                title: '닫기'
              }
            ]
          })
        })
          .catch(function (error) {
            alert(error.response.data);
          }).then(() => {

        })


      },


      set_package: function (ct_id) {
        var vm = this;
        axios.post('/adm/bbs/cs_item_package_insert.php', {
          cp_id: vm.wr_id,cr_id:vm.cr_id,cs_bo_table:vm.cs_bo_table
        }).then(function (response) {

          alert('현재 신청건에 추가되었습니다.');
          window.opener.vm.$refs.manageSchedule.getSchedules();

        })
          .catch(function (error) {
            alert(error.response.data);
          }).then(() => {

        })
      },
      say: function (message, event) {
        alert(event)
      },
      getPackages: function () {
        var vm = this;
        axios.post('/cs_schedule/get_packages.php', {
          wr_id: vm.wr_id,cs_bo_table:vm.cs_bo_table
        }).then(function (response) {

          vm.package_list = response.data.package_list;
        })
          .catch(function (error) {
            alert(error.response.data);
          }).then(() => {

        })
      },

    },

    mounted: function () {
      this.getPackages();

    },

    watch: {

    },
    components: {
      Timeline,
      TimelineItem,
      TimelineTitle
    }
  }
</script>

<style scoped>
  p {
    padding: 0;
  }

  thead th {
    border: 1px solid #ececec;
  }

  .table th, .table td {
    text-align: center;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/package_view.vue